'use client'

import { FC, useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { NextIntlClientProvider } from 'next-intl'
import BlogPostsList from '@/app/components/blog/BlogPostsList'
import { BlogPost } from '@/app/types/blog'

interface Props {
	language: string
	categorySlug?: string
	initialPosts: BlogPost[]
	initialTotal: number
	messages: Record<string, any>
}

const BlogPostsListWrapper: FC<Props> = ({
	language,
	categorySlug,
	initialPosts,
	initialTotal,
	messages,
}) => {
	const [queryClient] = useState(() => new QueryClient())

	return (
		<QueryClientProvider client={queryClient}>
			<NextIntlClientProvider locale={language} messages={messages}>
				<BlogPostsList
					language={language}
					categorySlug={categorySlug}
					initialPosts={initialPosts}
					initialTotal={initialTotal}
				/>
			</NextIntlClientProvider>
		</QueryClientProvider>
	)
}

export default BlogPostsListWrapper
